import React from 'react';
import './AngeboteBody.css';
import EmailFormDE from '../../components/EmailFormDE/EmailFormDE';
import useMediaQuery from '../../../hooks/useMediaQuery';

const AngeboteBody = ({
  title,
  headline,
  picURL,
  backgroundPic1,
  backgroundPic2,
  textColorDesktop,
  textColorMobile,
  campaignName,
  translations
}) => {
  const isUnder800 = useMediaQuery('(max-width: 800px)');

  return (
    <div className='rewards-body-container-main'>
      <div className="rewards-body-container">
        <div
          className="reward-body-item"
          id="body-photo-rewards"
          style={{ backgroundImage: `url(${backgroundPic1})` }}
        ></div>
        <div
          className="reward-body-item"
          style={{ backgroundImage: isUnder800 ? `url(${backgroundPic2})` : '' }}
        >
          <h2
            className="rewards-headline-text"
            style={{ color: isUnder800 ? textColorMobile : textColorDesktop }}
          >
            Sie qualifizieren sich für {headline}
          </h2>
          {picURL && <img id="promo-image" src={picURL} alt={headline} />}
          <br />
          <br />
          <div>
            <EmailFormDE 
              picURL={picURL} 
              pageType="angebote" 
              campaignName={campaignName}
              translations={translations}
            />
            <div className="disclaimer3">
              *NACH ABSCHLUSS DES KAUFS UND DER PROGRAMMANFORDERUNGEN. Handelsnamen oder Rechte, 
              die mit allen Marken auf dieser Website verbunden sind, sind Eigentum ihrer jeweiligen 
              Inhaber und nicht mit dieser Aktion verbunden.
            </div>
          </div>
          <br />
        </div>

        <div className="rewards-additional-info"></div>
      </div>
    </div>
  );
};

export default AngeboteBody;
